import React, { memo, useCallback } from 'react'
import { Box } from '@mui/material'
import useStyles from './styles'

const MOUNT_SX = {
    margin: 0,
    padding: 0,
} as const

export type ChartMountSurfaceProps = {
    viewKey: string
    showRestrictionOverlay: boolean
    isEmbedded: boolean
    /** No candles to read: show the plain arrow cursor instead of the crosshair cursor. */
    noData?: boolean
    onContextMenu?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
    onMount: (element: HTMLDivElement | undefined) => void
}

const ChartMountSurface = ({
    viewKey,
    showRestrictionOverlay,
    isEmbedded,
    noData = false,
    onContextMenu,
    onMount,
}: ChartMountSurfaceProps) => {
    const { classes } = useStyles()

    const handleRef = useCallback(
        (ref: HTMLDivElement | null) => {
            onMount(ref ?? undefined)
        },
        [onMount]
    )

    return (
        <Box
            ref={handleRef}
            id={`chart-${viewKey}`}
            className={classes.chartMount}
            sx={{
                ...MOUNT_SX,
                cursor: noData ? 'default' : 'crosshair',
                display: showRestrictionOverlay ? 'none' : 'block',
            }}
            onContextMenu={isEmbedded ? undefined : onContextMenu}
        />
    )
}

export default memo(ChartMountSurface)
